import { useTheme } from '@mui/material/styles';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { StatusPill } from '@components/StatusPill';

import { CurationStatus } from 'generated/types';

const messages = defineMessages({
  new: { id: 'curationBanner.new', defaultMessage: 'New' },
  needsReview: {
    id: 'curationBanner.needsReview',
    defaultMessage: 'Needs Review',
  },
  draft: { id: 'curationBanner.draft', defaultMessage: 'Draft' },
  published: { id: 'curationBanner.published', defaultMessage: 'Published' },
  preparation: {
    id: 'curationBanner.preparation',
    defaultMessage: 'Preparation',
  },
  structuring: {
    id: 'curationBanner.structuring',
    defaultMessage: 'Structuring',
  },
  inReview: { id: 'curationBanner.inReview', defaultMessage: 'In Review' },
  failed: { id: 'curationBanner.failed', defaultMessage: 'Failed' },
  complete: { id: 'curationBanner.complete', defaultMessage: 'Complete' },
});

const CurationStatusBadge: React.FC<{ status?: CurationStatus }> = ({
  status,
}) => {
  const { formatMessage } = useIntl();
  const { palette } = useTheme();

  if (!status) return null;

  let color = '';
  let message = '';

  switch (status) {
    // Original curation statuses
    case CurationStatus.NeedsReview:
      color = palette.orange.main;
      message = formatMessage(messages.needsReview);
      break;
    case CurationStatus.Draft:
      color = palette.warning.main;
      message = formatMessage(messages.draft);
      break;
    case CurationStatus.Published:
      color = palette.success.main;
      message = formatMessage(messages.published);
      break;
    // Discern-related statuses
    case CurationStatus.Preparation:
      color = palette.warning.main;
      message = formatMessage(messages.preparation);
      break;
    case CurationStatus.Structuring:
      color = palette.info.main;
      message = formatMessage(messages.structuring);
      break;
    case CurationStatus.InReview:
      color = palette.orange.main;
      message = formatMessage(messages.inReview);
      break;
    case CurationStatus.Failed:
      color = palette.error.main;
      message = formatMessage(messages.failed);
      break;
    case CurationStatus.Complete:
      color = palette.success.main;
      message = formatMessage(messages.complete);
      break;
    case CurationStatus.New:
    default:
      color = palette.pink.main;
      message = formatMessage(messages.new);
      break;
  }

  return <StatusPill color={color} name={message} />;
};

export default CurationStatusBadge;
